<!--<a class="promo-banner promo-with-icons promo-newyear" routerLink="/payment/add" *ngIf="checkViewBanner()">-->
<!--  <span class="promo-text">new year sale</span>-->
<!--  <img class="promo-icon" src="./assets/images/fireworks.png"/>-->
<!--  <span class="promo-text"> - 80% OFF</span>-->
<!--  <button class="btn btn-white" routerLink="/payment/add">GET IT NOW</button>-->
<!--  <app-countdown [startCounter]="getSecondsToEndOfPeriod()"></app-countdown>-->
<!--</a>-->

<!--<a class="promo-banner promo-with-icons promo-christmas" routerLink="/payment/add" *ngIf="checkViewBanner()">-->
<!--&lt;!&ndash;<a class="promo-banner promo-christmas" routerLink="/payment/add">&ndash;&gt;-->
<!--  <img class="promo-icon" src="./assets/images/christmas-bell.png"/>-->
<!--  <span class="promo-text">Christmas sale</span>-->
<!--  <img class="promo-icon" src="./assets/images/christmas-bell.png"/>-->
<!--  <span class="promo-text"> - 80% OFF</span>-->
<!--&lt;!&ndash;  <img class="promo-icon" src="./assets/images/christmas-ornament.png"/>&ndash;&gt;-->
<!--  <button class="btn btn-white" routerLink="/payment/add">GET IT NOW</button>-->
<!--  <app-countdown [startCounter]="getSecondsToEndOfPeriod()"></app-countdown>-->
<!--</a>-->

<!--<a class="promo-banner promo-with-icons promo-vday" routerLink="/payment/add" *ngIf="checkViewBanner()">-->
<!--  <img class="promo-icon" src="./assets/images/love.png"/>-->
<!--  <span class="promo-text font-decor">Valentine's Day</span>-->
<!--  <img class="promo-icon promo-icon-2" src="./assets/images/love.png"/>-->
<!--  <span class="promo-text"> - 80% OFF</span>-->
<!--&lt;!&ndash;  <img class="promo-icon" src="./assets/images/christmas-ornament.png"/>&ndash;&gt;-->
<!--  <button class="btn btn-white" routerLink="/payment/add">GET IT NOW</button>-->
<!--  <app-countdown [startCounter]="getSecondsToEndOfPeriod()"></app-countdown>-->
<!--</a>-->

<!--<a class="promo-banner promo-blackfriday" routerLink="/payment/add" *ngIf="checkViewBanner()">-->
<!--  <span class="promo-text">BLACK FRIDAY SALE - 80% OFF</span>-->
<!--  <button class="btn btn-white" routerLink="/payment/add">GET IT NOW</button>-->
<!--  <span class="promo-text">SPECIAL OFFER</span>-->
<!--  &lt;!&ndash;  <app-countdown [startCounter]="getSecondsToEndOfPeriod()"></app-countdown>&ndash;&gt;-->
<!--</a>-->

<!--<a class="promo-banner" routerLink="/payment/add" *ngIf="checkViewBanner()">-->
<!--  <span class="promo-text">#SocialAuditor {{getPromoName().toUpperCase()}} SALE - 70% OFF</span>-->
<!--  <button class="btn btn-white" routerLink="/payment/add">GET IT NOW</button>-->
<!--  <app-countdown [startCounter]="getSecondsToEndOfPeriod()"></app-countdown>-->
<!--</a>-->

<a class="promo-banner" routerLink="/payment/add" [ngStyle]="{'background-color': getPromoColor()}" *ngIf="checkViewBanner()">
  <span class="promo-text">
    #SocialAuditor SALE
<!--    <span class="promo-name">{{getPromoName().toUpperCase()}} SALE</span>-->
    - 70% OFF
  </span>
  <button class="btn btn-white" routerLink="/payment/add">GET IT NOW</button>
  <app-countdown [startCounter]="getSecondsToEndOfPeriod()"></app-countdown>
</a>
